// src/auth/Signup.js
import React, { useState } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import "./auth.css";

function Signup() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSignup = async () => {
    try {
      const res = await api.post("/signup", {
        email,
        password,
      });

      const { token, isNewUser } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("isAdmin", res.data.isAdmin);
      // localStorage.setItem("uid", uid);

      if (res.data.isAdmin) {
        navigate("/admin/client-report");}
      
      else if (isNewUser) {
        navigate("/register"); 
      } else {
        navigate("/profile");
      }
    } catch (err) {
      console.error("Signup error:", err.response?.data || err.message);
      alert(err.response?.data?.error || "Signup failed");
    }
  };

  const handleGoogleLogin = async (credentialResponse) => {
    try {
      const res = await api.post("/google-login", {
        token: credentialResponse.credential,
      });

      const { token, isNewUser } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("isAdmin", res.data.isAdmin);
      const isAdmin = localStorage.getItem("isAdmin") === "true";
      console.log("admin: ", res.data.isAdmin)
      if (isAdmin) {
        navigate("/admin/client-report");}
      
      else if (isNewUser) {
        navigate("/register"); 
      } else {
        navigate("/profile");
      }
    } catch (err) {
      console.error("Google login failed", err.response?.data);
      alert("Google Login Failed");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h1>Sign Up</h1>

        <input
          className="auth-form input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          type="email"
          required
        />

        <input
          className="auth-form input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          type="password"
          required
        />

        <button onClick={handleSignup}>Sign Up</button>

        <GoogleLogin
          onSuccess={(credentialResponse) => {
            console.log("Google Credential Response:", credentialResponse);
            handleGoogleLogin(credentialResponse);
          }}
          onError={() => alert("Google Sign-In Error")}
        />

        <div style={{ marginTop: "16px", textAlign: "center" }}>
          <a href="/login" style={{ color: "#27548A", textDecoration: "none" }}>
            Already have an account? <u>Login</u>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Signup;
